import React from 'react';
import './SplashScreen.css'; // Optional: for custom styles

const SplashScreen = () => (
  <div className="splash-screen">
    <div className="loading-indicator">Loading...</div>
  </div>
);

export default SplashScreen;